import { root } from 'app/store/constants';
import { Dispatch, ThunkAction } from 'app/types/actions';
import { BACK_BOARD_LOCALSTORAGE } from 'app/const';

export const onBackClick = (): ThunkAction => {
    const action = (
        dispatch: Dispatch
    ) => {
        const boardId = localStorage.getItem(BACK_BOARD_LOCALSTORAGE);
        root.App.router.setCurrentDashboard(boardId, false);
        root.App.router.navigate(root.App.router.getUrl(null), {trigger: true});
    }
    return action;
};
